import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Card } from "components/Dashboard/components";
import NoPermission from "components/Dashboard/components/NoPermission";
import { useGetFilterParams } from "components/Dashboard/hooks";
import {
    API_IS_BEING_CANCELLED,
    ENDPOINTS,
    FILTER_NAMES,
    useApi,
    useIsMounted,
    usePermissions
} from "shared";

import { EMPTY_STATE, LOADING_STATE } from "./constants";
import DoughnutChart from "./DoughnutChart";
import { StatsEntry } from "./types";

const DeviceStatus = () => {
    const { t } = useTranslation();
    const { cancelSource, queryData, handleResponse, isCanceled } = useApi();
    const { stringifiedFilterParams } = useGetFilterParams();
    const { isReadDeviceNotAllowed } = usePermissions();
    const isMounted = useIsMounted();

    const [data, setData] = useState<StatsEntry[]>(LOADING_STATE);

    useEffect(() => {
        const getStats = async () => {
            try {
                setData(LOADING_STATE);

                const { data } = await queryData(
                    `${ENDPOINTS.DeviceStats}?field=${FILTER_NAMES.ActivityStatus}`,
                    stringifiedFilterParams
                );

                if (isMounted) {
                    const dataValues = Object.values(data);
                    const isEmpty = dataValues.length === 0;

                    const finalData = (
                        isEmpty ? EMPTY_STATE : dataValues
                    ) as StatsEntry[];

                    setData(finalData);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                    setData(EMPTY_STATE);
                }
            }
        };

        !isReadDeviceNotAllowed && getStats();

        return () => {
            cancelSource.cancel(API_IS_BEING_CANCELLED);
        };
        // eslint-disable-next-line
    }, [isReadDeviceNotAllowed, stringifiedFilterParams]);

    return (
        <Card
            title={t("Dashboard##title##device status")}
            headerCustomStyle={{
                minHeight: isReadDeviceNotAllowed ? "40px" : "unset"
            }}
            containerCustomStyle={{ height: "100%" }}
        >
            {isReadDeviceNotAllowed ? (
                <NoPermission
                    customStyle={{
                        margin: "0 30px",

                        "@media (max-width: 1439px)": {
                            marginBottom: "16px"
                        }
                    }}
                />
            ) : (
                <DoughnutChart stats={data} />
            )}
        </Card>
    );
};

export default DeviceStatus;
